/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import MuiDrawer, { DrawerProps as MuiDrawerProps } from '@mui/material/Drawer';
import React from 'react';

import { Colors } from 'src/common/ui/base/Colors';
import { Spacing } from 'src/common/ui/base/Spacing';

/**
 * Drawer component for displaying side panels.
 * This component wraps the Material-UI Drawer component and applies Boulder's design system.
 */
export const Drawer = ({
  anchor = 'right',
  children,
  className,
  hideBackdrop = false,
  onClose,
  open,
  variant = 'temporary',
  width = `${Spacing.Unit2 * 6 * 10}px`,
}: React.PropsWithChildren<{
  anchor?: MuiDrawerProps['anchor'];
  children: React.ReactNode;
  className?: string;
  hideBackdrop?: boolean;
  onClose: () => void;
  open: boolean;
  variant?: MuiDrawerProps['variant'];
  width?: string;
}>) => (
  <MuiDrawer
    PaperProps={{ style: { width } }}
    anchor={anchor}
    className={className}
    data-testid="nds-component-drawer"
    hideBackdrop={hideBackdrop}
    onClose={onClose}
    open={open}
    variant={variant}
    css={css`
      .MuiDrawer-paper {
        background-color: ${Colors.White};
        box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
        padding: ${Spacing.Unit4}px;
      }
    `}
  >
    {children}
  </MuiDrawer>
);
